import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import ReactTable from 'react-table';
import {
  defaultTableFiltering,
} from '../../../utils';

const propTypes = exact({
  userTimesheets: PropTypes.array.isRequired,
});

const AwaitingApproval = (props) => {
  return (
    <div>
      <ReactTable
        data={props.userTimesheets}
        filterable
        defaultFilterMethod={(filter, row) => {
          return defaultTableFiltering(filter, row);
        }}
        columns={[
          {
            Header: 'Name',
            id: 'fullname',
            accessor: (ts) => { return ts.node.user.fullname; },
          },
          {
            Header: 'Supervisor',
            id: 'supervisor_name',
            accessor: (ts) => {
              const { user } = ts.node;
              let name = 'None';

              if (user.supervisor) {
                name = user.supervisor.fullname;
              }

              return name;
            },
          },
          {
            Header: 'Week of',
            id: 'week_of',
            accessor: (ts) => { return ts.node.start_date.display; },
          },
        ]}
        defaultPageSize={10}
        className="-striped -highlight"
      />
    </div>
  );
};

AwaitingApproval.propTypes = propTypes;

export default AwaitingApproval;
